/***
 * File name: analyticsTable.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Analytics and Ratings.
 */
const analyticsTable = {

  rolesHeaders: [
    { value: 'actionType', text: 'Roles', sortable: false },
    { value: 'status', text: 'Status', sortable: false },
    { value: 'action', text: 'Action', sortable: false, align: 'end', class: 'pr-12' }
  ],
  usersHeaders: [
    { value: 'users', text: 'Users' },
    { value: 'action', text: 'Action', sortable: false, align: 'end', class: 'pr-4' }
  ]

}

export default analyticsTable
